// extracted by mini-css-extract-plugin
export default {"wrapper":"EditProjectGeneralForm_wrapper__39JB-","submitWrapper":"EditProjectGeneralForm_submitWrapper__S-DoS"};